'use strict';

var $ = require('jquery');

var VISIBLE_CLASS = 'is-visible';
var HIDDEN_CLASS = 'u-hidden';
var LANGAUGE_CLASS = 'language-popup-active';
var SELECTORS = {
    POPUP: '.js-popup',
    POPUP_BUTTON: '.js-popup__close',
    SET_NEW_FOCUS: '#screenreaderFocus'
};

function showPopup(elem) {
    elem.removeClass(HIDDEN_CLASS);
    return elem.addClass(VISIBLE_CLASS);
}

function hidePopup(elem) {
    elem.addClass(HIDDEN_CLASS);
    return elem.removeClass(VISIBLE_CLASS);
}

function init() {
    var popups = $(SELECTORS.POPUP);
    if (popups.length) {
        popups.each(function() {
            var popup = $(this);
            var popupId = popup.data('popupId');
            var popupStorageKey = 'app.popup-hidden-' + popupId;
            var popupButton = popup.find(SELECTORS.POPUP_BUTTON);
            var popupScrollInterval;
            var isHidden;

            try {
                isHidden = localStorage.getItem(popupStorageKey);
            } catch (e) {} // eslint-disable-line no-empty


            if (!isHidden) {
                var did_scroll = false,
                $window = $(window),
                primary_content_distance = $('.global-container').offset().top;

                $window.on('scroll', function (event) {
                    did_scroll = true;
                });

                popupScrollInterval = setInterval(function () {
                    if (did_scroll) {
                        did_scroll = false;

                        if ($window.scrollTop() >= primary_content_distance) {
                            showPopup(popup);
                            popupButton.focus();
                        }
                    }
                }, 250);
            }

            popupButton.on('click.popups', function(evt) {
                evt.preventDefault();
                clearInterval(popupScrollInterval);
                hidePopup(popup);

                if (document.body.classList.contains("user-is-tabbing")) {
                    $(SELECTORS.SET_NEW_FOCUS).focus();
                }

                try {
                    localStorage.setItem(popupStorageKey, true);
                } catch (e) {} // eslint-disable-line no-empty
            });

            $(document).keydown(function(event) {
                if (event.keyCode == 27) {
                    clearInterval(popupScrollInterval);
                    hidePopup(popup);

                    if (document.body.classList.contains("user-is-tabbing")) {
                        $(SELECTORS.SET_NEW_FOCUS).focus();
                    }

                    try {
                        localStorage.setItem(popupStorageKey, true);
                    } catch (e) {} // eslint-disable-line no-empty
                }
            });
        });
    }
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/popup.js